// Use Slick carousel for progression

jQuery('.m-review__slides').slick({
  arrows: false,
	fade: false,
	slidesToShow: 1
});

jQuery('.m-review__slides').on('afterChange', function(slides, current) {
  jQuery('.m-review__slides-counter ul li').removeClass('active');
  jQuery('.m-review__slides-counter ul li').eq(current.currentSlide).addClass('active');
});

// Update text fields

jQuery("#review_heading").on('input',function(){
    mytarget = "#" + jQuery(this).attr("data-target");
    jQuery(mytarget).val(jQuery(this).val()).trigger('change');
});

jQuery("#review_comment").on('input',function(){
    mytarget = "#" + jQuery(this).attr("data-target");
    jQuery(mytarget).val(jQuery(this).val()).trigger('change');
});


// Next button (if enabled by choosing a rating on current slide)

jQuery(".m-review__next").each(function() {

    jQuery(this).bind('click',function(){
        if (!jQuery(this).is(':disabled')) {
            jQuery('.m-review__slides').slick('slickNext');
        }
    });

});


// Previous button

jQuery(".m-review__prev").each(function() {

    jQuery(this).bind('click',function(){
        jQuery('.m-review__slides').slick('slickPrev');
    });

});


// Star rating

jQuery(".m-review__star").each(function() {

    jQuery(this).bind('click',function(){
        myrating = "m-review__rating-" + jQuery(this).attr("data-value");
        mytarget = "#" + jQuery(this).closest("ul").attr("data-target");
        jQuery(this).closest('ul').attr('data-rating',jQuery(this).attr("data-value"));
        jQuery(this).closest('ul').next('.m-review__slide-navigation').find('.m-review__next').prop('disabled',false).focus();
        jQuery(this).closest('ul').next('.m-review__slide-navigation').find('.m-review__submit').prop('disabled',false).focus();
        jQuery(mytarget).val(jQuery(this).attr("data-value")).trigger('change');
    });

});


// Submit review

jQuery(".m-review__submit").bind('click',function(){
    jQuery("#submit").click();
});